import React from "react";
import { Delete } from "../ProjectIcons";

type DeleteButtonProps = {
	onClick: () => void;
	className?: string;
	ariaLabel?: string;
	disabled?: boolean;
};

const DeleteButton: React.FC<DeleteButtonProps> = ({
	onClick,
	className = "text-unlisted-orange p-2 mx-2 h-12 transition-all duration-300 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed",
	ariaLabel = "Delete",
	disabled = false,
}) => {
	return (
		<button
			className={className}
			onClick={onClick}
			aria-label={ariaLabel}
			disabled={disabled}
		>
			<Delete />
		</button>
	);
};

export default DeleteButton;
